import LibraryResolver from 'resolvers/RTMResolvers/LibraryResolver';

export default (() => {
  let libraryResolver;
  let isRegistered = false;

  const getLibraryList = async () => {
    if (!libraryResolver) {
      return [];
    }

    return libraryResolver.workspaceLibraryList();
  };

  return {
    isRegistered: () => isRegistered,
    register: (connectionProvider) => {
      isRegistered = true;
      libraryResolver = new LibraryResolver(connectionProvider);
    },
    getLibraryList,
  };
})();
